import { useEffect } from 'react';
import { useUpdateNodeInternals, type NodeProps } from '@xyflow/react';
import BaseNode from './BaseNode';
import { type SectionNodeData } from '@app/services/aiFlow.types';

function SectionNode(props: NodeProps) {
    const { data, id } = props;
    const sectionData = data as SectionNodeData;

    const updateNodeInternals = useUpdateNodeInternals();
    useEffect(() => {
        updateNodeInternals(id);
    }, [data.visConditionSlots, id, updateNodeInternals]);

    return (
        <BaseNode
            id={id}
            type="section"
            content={sectionData.name}
            visConSlots={sectionData.visConditionSlots}
        />
    );
}

export default SectionNode;
